import { render, staticRenderFns } from "./DonationSuggestion.vue?vue&type=template&id=4a5bb1da&scoped=true"
import script from "./DonationSuggestion.vue?vue&type=script&lang=js"
export * from "./DonationSuggestion.vue?vue&type=script&lang=js"
import style0 from "./DonationSuggestion.vue?vue&type=style&index=0&id=4a5bb1da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5bb1da",
  null
  
)

export default component.exports